import { createAction } from 'typesafe-actions';

export const setPage = createAction('CRITICAL_ALERTS_PAGE_SET', action => (pageIndex: number) => action(pageIndex));
export const setPageSize = createAction('CRITICAL_ALERTS_PAGE_SIZE_SET', action => (pageSize: number) =>
  action(pageSize)
);
